export const countryCodes = [
  { code: "+1", label: "USA" },
  { code: "+7", label: "Russia" },
  { code: "+20", label: "Egypt" },
  { code: "+27", label: "South Africa" },
  { code: "+30", label: "Greece" },
  { code: "+31", label: "Netherlands" },
  { code: "+32", label: "Belgium" },
  { code: "+33", label: "France" },
  { code: "+34", label: "Spain" },
  { code: "+36", label: "Hungary" },
  { code: "+39", label: "Italy" },
  { code: "+40", label: "Romania" },
  { code: "+41", label: "Switzerland" },
  { code: "+43", label: "Austria" },
  { code: "+44", label: "UK" },
  { code: "+45", label: "Denmark" },
  { code: "+46", label: "Sweden" },
  { code: "+47", label: "Norway" },
  { code: "+48", label: "Poland" },
  { code: "+49", label: "Germany" },
  { code: "+51", label: "Peru" },
  { code: "+52", label: "Mexico" },
  { code: "+53", label: "Cuba" },
  { code: "+54", label: "Argentina" },
  { code: "+55", label: "Brazil" },
  { code: "+56", label: "Chile" },
  { code: "+57", label: "Colombia" },
  { code: "+58", label: "Venezuela" },
  { code: "+60", label: "Malaysia" },
  { code: "+61", label: "Australia" },
  { code: "+62", label: "Indonesia" },
  { code: "+63", label: "Philippines" },
  { code: "+64", label: "New Zealand" },
  { code: "+65", label: "Singapore" },
  { code: "+66", label: "Thailand" },
  { code: "+81", label: "Japan" },
  { code: "+82", label: "South Korea" },
  { code: "+84", label: "Vietnam" },
  { code: "+86", label: "China" },
  { code: "+90", label: "Turkey" },
  { code: "+91", label: "India" },
  { code: "+92", label: "Pakistan" },
  { code: "+93", label: "Afghanistan" },
  { code: "+94", label: "Sri Lanka" },
  { code: "+95", label: "Myanmar" },
  { code: "+98", label: "Iran" },
  { code: "+212", label: "Morocco" },
  { code: "+213", label: "Algeria" },
  { code: "+216", label: "Tunisia" },
  { code: "+218", label: "Libya" },
  { code: "+220", label: "Gambia" },
  { code: "+221", label: "Senegal" },
  { code: "+234", label: "Nigeria" },
  { code: "+250", label: "Rwanda" },
  { code: "+255", label: "Tanzania" },
  { code: "+256", label: "Uganda" },
  { code: "+260", label: "Zambia" },
  { code: "+263", label: "Zimbabwe" },
  { code: "+264", label: "Namibia" },
  { code: "+267", label: "Botswana" },
  { code: "+268", label: "Eswatini" },
  { code: "+290", label: "Saint Helena" },
  { code: "+299", label: "Greenland" },
  { code: "+350", label: "Gibraltar" },
  { code: "+351", label: "Portugal" },
  { code: "+352", label: "Luxembourg" },
  { code: "+353", label: "Ireland" },
  { code: "+354", label: "Iceland" },
  { code: "+355", label: "Albania" },
  { code: "+356", label: "Malta" },
  { code: "+357", label: "Cyprus" },
  { code: "+358", label: "Finland" },
  { code: "+359", label: "Bulgaria" },
  { code: "+370", label: "Lithuania" },
  { code: "+371", label: "Latvia" },
  { code: "+372", label: "Estonia" },
  { code: "+373", label: "Moldova" },
  { code: "+374", label: "Armenia" },
  { code: "+375", label: "Belarus" },
  { code: "+376", label: "Andorra" },
  { code: "+377", label: "Monaco" },
  { code: "+378", label: "San Marino" },
  { code: "+380", label: "Ukraine" },
  { code: "+381", label: "Serbia" },
  { code: "+382", label: "Montenegro" },
  { code: "+383", label: "Kosovo" },
  { code: "+385", label: "Croatia" },
  { code: "+386", label: "Slovenia" },
  { code: "+387", label: "Bosnia and Herzegovina" },
  { code: "+389", label: "North Macedonia" },
  { code: "+420", label: "Czech Republic" },
  { code: "+421", label: "Slovakia" },
  { code: "+423", label: "Liechtenstein" },
  { code: "+500", label: "Falkland Islands" },
  { code: "+501", label: "Belize" },
  { code: "+502", label: "Guatemala" },
  { code: "+503", label: "El Salvador" },
  { code: "+504", label: "Honduras" },
  { code: "+505", label: "Nicaragua" },
  { code: "+506", label: "Costa Rica" },
  { code: "+507", label: "Panama" },
  { code: "+509", label: "Haiti" },
  { code: "+672", label: "Antarctica" },
  { code: "+673", label: "Brunei" },
  { code: "+674", label: "Nauru" },
  { code: "+675", label: "Papua New Guinea" },
  { code: "+676", label: "Tonga" },
  { code: "+677", label: "Solomon Islands" },
  { code: "+678", label: "Vanuatu" },
  { code: "+679", label: "Fiji" },
  { code: "+680", label: "Palau" },
  { code: "+681", label: "Wallis and Futuna" },
  { code: "+682", label: "Cook Islands" },
  { code: "+683", label: "Niue" },
  { code: "+685", label: "Samoa" },
  { code: "+686", label: "Kiribati" },
  { code: "+687", label: "New Caledonia" },
  { code: "+688", label: "Tuvalu" },
  { code: "+689", label: "French Polynesia" },
  { code: "+690", label: "Tokelau" },
  { code: "+691", label: "Micronesia" },
  { code: "+692", label: "Marshall Islands" },
];
